(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@feature-hub/react"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@feature-hub/react", "react", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@feature-hub/react"), require("react"), require("react-dom")) : factory(root["@feature-hub/react"], root["React"], root["ReactDOM"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__9544__, __WEBPACK_EXTERNAL_MODULE__4119__, __WEBPACK_EXTERNAL_MODULE__9545__) => {
return 